// Modal Content, This content is mainly used for Modal with MainModal.tsx Component
import React from "react";
import { IoMdArrowRoundUp } from "react-icons/io";
import SearchBar from "./SearchBar";

const PaymentHistory = () => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-normal mb-3">Here you can find all your payments  <br /> in terms of group.</p>
      <SearchBar  className="bg-white w-full rounded-full text-xs mb-3" inputCss="bg-white" placeholder="Search language" />
      {
        [...Array(5)].map((_, index) => (
          <div key={index} className="bg-white p-3 rounded-xl flex items-center justify-between mb-2">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#EAE9EF] flex items-center justify-center">
                <IoMdArrowRoundUp className="w-4 h-4" />
              </div>
              <div>
                <h1 className="text-[#0F0C18] text-base font-medium tracking-tight">Translation to English</h1>
                <p className="text-[#9392A2] text-xs font-medium tracking-tight">23.09.2023 • 23:14</p>
              </div>
            </div>
            <p className="text-[#0F0C18] text-base font-medium tracking-tight">– $ 25.00</p>
          </div>
        ))
      }
    </>
  );
};

export default PaymentHistory;